import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterContact from '../../../component/FooterContact';
import HomeVideo2 from '../../../assets/images/banner/banner-1.mp4';

export default function Ransomware() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Hero */}
            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                <div className="overlay-top-left"></div>
                <div className="container">
                    <div className="row align-items-center height100">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-caption">
                                <div itemScope itemType="http://schema.org/BreadcrumbList" className="breadcrumbs">
                                    <ul>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <Link to="/"><span itemProp="name">Home</span></Link>
                                            <meta itemProp="position" content="1" />
                                        </li>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <i className="icofont-thin-right"></i>
                                            <span itemProp="name">Ransomware</span>
                                            <meta itemProp="position" content="2" />
                                        </li>
                                    </ul>
                                </div>
                                <div className="prod-section-label">Ransomware Defense</div>
                                <h1 className="prod-hero-title">Stop <span>Ransomware</span> Before It Stops You</h1>
                                <p>Ransomware is a constantly evolving type of malware that encrypts files on a device, rendering systems inaccessible. Attackers then demand a ransom in exchange for restoring access through decryption.</p>
                                <div className="button_services mt-4">
                                    <Link to="/contact"><button className="prod-cta-btn">Contact Us &nbsp;<i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12">
                            <div className="banner-mobiles text-center">
                                <img src={require('../../../assets/images/services/products/data-bg-transparant.webp')} alt="Ransomware Protection" />
                            </div>
                        </div>
                    </div>
                </div>
                <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>

            {/* Stats */}
            <section style={{ background: '#0a0a0a', padding: '0 0 20px' }}>
                <div className="container">
                    <div className="prod-stats-row">
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">$6T+</div>
                            <div className="prod-stat-label">Annual Cybercrime Cost</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">$4.45M</div>
                            <div className="prod-stat-label">Avg. Breach Cost</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">73%</div>
                            <div className="prod-stat-label">SMBs Attacked</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">24/7</div>
                            <div className="prod-stat-label">Continuous Protection</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Overview */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/Ransom.jpg')} alt="Ransomware Protection" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">What is Ransomware?</div>
                                <h2>Stop Ransomware in Its Tracks</h2>
                                <p>Ransomware is an ever-evolving form of malware designed to encrypt files on a device, rendering systems unusable. Malicious actors then demand ransom in exchange for decryption — often also threatening to sell or leak exfiltrated data.</p>
                                <p>Cloud Mind has partnered with the world's top security companies to provide a robust, multi-layered solution to stop ransomware before it causes damage to your business.</p>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '12px', display: 'inline-flex' }}>
                                    Get Protected <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Financial Impact & Protection */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="row align-items-center mb-5 pb-4" style={{ borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                        <div className="col-lg-6 order-lg-2">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/finencial-impact.webp')} alt="Financial Impact" />
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-1">
                            <div className="prod-info-content" style={{ paddingLeft: 0, paddingRight: 40 }}>
                                <div className="prod-section-label">Financial Impact</div>
                                <h2>The Real Cost of Ransomware</h2>
                                <p>Cybercrime will cost the world in excess of $6 trillion annually — ransomware making up a proportionately larger and growing share. The financial and operational damage goes far beyond the ransom payment itself, including downtime, reputational harm, and regulatory penalties.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center mt-5 pt-2">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/protection.webp')} alt="Ransomware Protection" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Best Practices</div>
                                <h2>Protecting Against Ransomware</h2>
                                <ul className="prod-benefits-list">
                                    <li><span className="ben-dot">✓</span>Never click on unsafe or suspicious links</li>
                                    <li><span className="ben-dot">✓</span>Avoid disclosing personal information online</li>
                                    <li><span className="ben-dot">✓</span>Do not open suspicious email attachments</li>
                                    <li><span className="ben-dot">✓</span>Never use unknown USB sticks or external devices</li>
                                    <li><span className="ben-dot">✓</span>Keep all programs and operating systems up to date</li>
                                    <li><span className="ben-dot">✓</span>Use VPN services on public networks</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Anti-Ransomware Technologies */}
            <section className="prod-dark-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/anti-ransom.webp')} alt="Anti-Ransomware Technology" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Anti-Ransomware Technologies</div>
                                <h2>World-Class Technologies to Stop Ransomware</h2>
                                <p>Cloud Mind has partnered with world-class technology companies to provide comprehensive anti-ransomware solutions including:</p>
                                <div className="prod-features-grid" style={{ padding: '16px 0 0', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                                    {['Artificial Intelligence', 'Machine Learning', 'Deception Technologies', 'Multilayer Protection', 'Anti-Ransom Tools', 'Data Protection', 'Patch Management', 'Incident Response'].map((tech, i) => (
                                        <div key={i} style={{ background: 'rgba(255,107,53,0.06)', border: '1px solid rgba(255,107,53,0.15)', borderRadius: 10, padding: '10px 14px', color: 'rgba(255,255,255,0.8)', fontSize: 13, fontWeight: 600 }}>
                                            <span style={{ color: '#ff6b35', marginRight: 8 }}>▸</span>{tech}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section style={{ background: '#0a0a0a', padding: '0 0 80px' }}>
                <div className="container">
                    <div className="prod-cta-banner">
                        <div>
                            <h3>Don't Wait for a Ransomware Attack</h3>
                            <p>Get a comprehensive ransomware risk assessment and protection strategy tailored to your organization.</p>
                        </div>
                        <Link to="/contact" className="prod-cta-btn">
                            Get Protected <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
